<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Work Orders"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Create new work orders."
      @on-submit="createWorkOrderImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Work Orders Template.xlsx"
              :file-provider="$importsAPI.getWorkOrdersTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'WorkOrdersImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'work-orders-imports-add-modal',
    };
  },
  methods: {
    createWorkOrderImport(data, handleCreate) {
      handleCreate(this.$importsAPI.workOrdersCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
